var React = require('react');

function IconHome (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M16.25 6.82578V1.875H13.125V4.1582L10 1.25L0 10.625H2.5V18.75H8.125V12.5H11.875V18.75H17.5V10.625H20L16.25 6.82578Z","fill":"white"}));
}

IconHome.defaultProps = {"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none"};

module.exports = IconHome;

IconHome.default = IconHome;
